import { UseUserPermission } from './type'
import { usePermissionProvider } from './usePermissionProvider'

export const useUserPermission = (): UseUserPermission => {
  const { currentPermissions, error, isLoading, menuConfig } = usePermissionProvider()
  return {
    currentPermissions,
    error,
    isLoading,
    menuConfig,
  }
}
